import * as z from "zod/v4";

export const outreachGroupKeys = [
  "automation",
  "automationStepId",
  "campaign",
  "template",
  "domain",
] as const;

export type OutreachGroupKey = Partial<
  Record<(typeof outreachGroupKeys)[number], string | null>
>;

export const OutreachGroupKeySchema = z
  .object({
    automation: z.string().nullish(),
    automationStepId: z.string().nullish(),
    campaign: z.string().nullish(),
    template: z.string().nullish(),
    domain: z.string().nullish(),
  })
  .partial();

export const outreachProducts = ["marketing", "order tracking"] as const;

export const outreachMetrics = [
  "complaints",
  "bounces",
  "sends",
  "deliveries",
  "opens",
  "uniqueOpens",
  "clicks",
  "uniqueClicks",
  "upsellCount",
  "upsellRevenue",
  "failures",
  "skippedDueToUnsubscribe",
  "skippedDueToSkipConditions",
  "unsubscribes",
] as const;

export type OutreachMetric = (typeof outreachMetrics)[number];

export enum OutreachEventType {
  Complaint = "complaint",
  Bounce = "bounce",
  Send = "send",
  Delivery = "delivery",
  Open = "open",
  Click = "click",
}

export const validOutreachGroupings: Set<keyof OutreachGroupKey>[] = [
  new Set([]),
  new Set(["campaign"]),
  new Set(["campaign", "template"]),
  new Set(["automation"]),
  new Set(["automation", "automationStepId"]),
  new Set(["automation", "automationStepId", "template"]),
  new Set(["domain"]),
];
